import styled from '@emotion/styled';
import { isPC } from 'constants/layout';
import { IkImage } from 'ui-components/Imagekit/IkImage';

export type Style = {
  width: number;
  height: number;
  title: string;
  description: string;
};

export const StyledItemWrapper = styled.div<{ itemStyle: Style }>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: ${props => props.itemStyle.width}px;
  height: ${props => props.itemStyle.height}px;
  border-radius: 6px;

  scroll-snap-align: center;
  scroll-snap-stop: always;

  @media (${isPC}) {
    scroll-snap-align: start;
  }
`;

export const StyledBackgroundImage = styled(IkImage)<{ itemStyle: Style }>`
  width: 100%;
  height: 100%;
  max-width: ${props => props.itemStyle.width}px;
  max-height: ${props => props.itemStyle.height}px;
  left: 0;
  top: 0;
  border-radius: 6px;
`;

export const StyledTextWrapper = styled.div`
  position: absolute;
  width: 64px;
`;

export const StyledTitle = styled.p`
  font-size: 12px;
  color: #000;
  margin-top: 8px;
  text-align: center;
`;
